<template>
  <q-dialog v-model="edit">
    <q-card style="width:320px">
      <q-form @submit="onSubmit">
        <div class="q-pa-md">
          <div class="row">
            <div class="col-12">
              <q-input
                outlined
                label="Custom Tag Name*"
                v-model="name"
                :rules="[val => (val !== null && val !== '') || 'Please type manual name']"
              ></q-input>
            </div>
            <div class="col-12" style="margin-top:5px">
              <q-input
                outlined
                label="Custom Tag Color*"
                v-model="color"
                :rules="[isValidColor]"
                class="my-input"
              >
                <template v-slot:append>
                  <q-icon name="fas fa-paint-brush" size="14px" class="cursor-pointer">
                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                      <q-color no-header no-footer v-model="color" />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div style="display:flex;justify-content:flex-end" class="col-12">
              <q-btn label="Close" @click="edit = false" color="negative" style="margin-right:5px"></q-btn>
              <q-btn :loading="loading" label="Save" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import isValidColor from '../helper/colorValidation'
import axios from '../axios'
export default {
  data() {
    return {
      loading: false,
      name: '',
      color: ''
    }
  },
  methods: {
    isValidColor,
    async onSubmit() {
      // server fire
      this.loading = true
      const { data } = await axios.patch(`vehicle-tag/${this.selectedTag.id}`, { name: this.name, color: this.color })
      this.loading = false
      const copy = {
        ...this.selectedTag,
        name: this.name,
        color: this.color
      }
      this.$store.commit(`tag/UPDATE_TAG`, copy)
      this.$root.$emit('tagUpdateCheckVehicles', copy)
      this.edit = false
    }
  },
  computed: {
    edit: {
      get() {
        return this.$store.state.tag.edit
      },
      set(val) {
        this.$store.commit('tag/SET_EDIT', val)
      }
    },
    selectedTag: {
      get() {
        return this.$store.state.tag.selectedTag
      },
      set(val) {
        this.$store.commit('tag/SET_SELECTED_TAG', val)
      }
    }
  },
  watch: {
    edit(n, o) {
      if (n) {
        const { name, color } = this.selectedTag
        this.name = name
        this.color = color
      } else {
        this.name = ''
        this.color = ''
      }
    }
  }
}
</script>
